<ng-content select="[leading]"></ng-content>
<div class="titles">
    @if (eyebrow()) {
        <span class="eyebrow">{{ eyebrow() }}</span>
    }
    <div class="title-row">
        <h1>{{ title() }}</h1>
        <ng-content select="[after-title]"></ng-content>
    </div>
    <ng-content></ng-content>
</div>
<div class="actions">
    <ng-content select="[actions]"></ng-content>
</div>
